import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnInit,
} from '@angular/core';
import { FlexLayoutType } from '../../constants/flex-layout.type';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { formatBytes } from '../../utils/format-bytes';
import { DocumentUploadStatus } from '../../constants/document-upload-status.type';
import { FormBuilder } from '@angular/forms';
import { UploadMaterialMetadataModel } from '../../models/document-metadata.model';
import { DocumentUploadModel } from '../../models/document-upload.model';
@Component({
  selector: 'jsg-file-upload-card-view',
  templateUrl: './file-upload-card-view.component.html',
  styleUrls: ['./file-upload-card-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JsgFileUploadCardComponent implements OnInit {
  @Input() cardHeading: string;
  @Input() helpText: string;
  @Input() isRequired: boolean;
  @Input() uploadedDocument: DocumentUploadModel;
  @Output() selectFile = new EventEmitter<NgxFileDropEntry>();
  @Output() cancelUpload = new EventEmitter();
  @Output() deleteUpload = new EventEmitter<string>();
  @Output() openFile = new EventEmitter<UploadMaterialMetadataModel>();
  @Output() deleteCard = new EventEmitter();

  public FlexLayoutType = FlexLayoutType;
  public DocumentUploadStatus = DocumentUploadStatus;
  public formatBytes = formatBytes;

  constructor() {}

  ngOnInit() {}

  public onSelectFile = (file: NgxFileDropEntry) => {
    this.selectFile.emit(file);
  };

  public onCancelUpload = () => {
    this.cancelUpload.emit();
  };

  public onDeleteUpload = (documentId: string) => {
    this.deleteUpload.emit(documentId);
  };

  public onOpenFile = (documentId: string) => {
    this.openFile.emit(this.uploadedDocument.document);
  };

  public ondeleteCardClick = () => {
    this.deleteCard.emit();
  };
}
